import { InfoTooltip } from "@components/molecules/InfoTooltip";

export const ValenceInfoTooltip = () => (
  <InfoTooltip content="Specify how the value should be interpreted – good (positive), bad (negative), or neutral" />
);
